import React, { useState } from "react";
import { LocalizationProvider, StaticDatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function MonthCalendarPicker({
  open,
  onClose,
  onDateSelect,
  selectedDate,
  setSelectedDate,
}) {
  const handleDateChange = (newValue) => {
    setSelectedDate(newValue);
    onDateSelect(newValue);
    onClose();
  };
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle sx={{ fontWeight: 600 }}>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Box>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <StaticDatePicker
              displayStaticWrapperAs="desktop"
              openTo="day" // show month view first
              maxDate={new Date()}
              views={["year", "month", "day"]} // allow full navigation
              value={selectedDate}
              onChange={(newValue) => handleDateChange(newValue)}
              slotProps={{
                actionBar: { actions: [] }, // no OK/Cancel buttons
              }}
            />
          </LocalizationProvider>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
